'use client';

import { c as _c } from "react/compiler-runtime";
import CalendarIcon from '@eversports/design-tokens/assets/icons/regular/calendar.svg?icon';
import { cn } from '@eversports/klimt-design-components/tailwind/utils';
import Button from '@eversports/klimt-primitives/Button';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { Calendar } from '../../../../../../../../../components/Calendar';
import { Sheet, SheetTrigger } from '../../../../../../../../../components/Sheet';
import FilterSheetContent from '../FilterSheetContent';
interface Props {
  selectedDate?: Date;
  formattedDate?: string;
  updateFilter: (value: Date | undefined) => void;
  resetFilter: () => void;
}
const DateFilterSheet = t0 => {
  const $ = _c(37);
  const {
    selectedDate,
    formattedDate,
    updateFilter,
    resetFilter
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const t = useTranslations("discover-sport-city");
  let t1;
  if ($[0] !== isOpen) {
    t1 = () => setIsOpen(!isOpen);
    $[0] = isOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const toggleCalendar = t1;
  let t2;
  if ($[2] !== toggleCalendar || $[3] !== updateFilter) {
    t2 = dateSelection => {
      updateFilter(dateSelection);
      toggleCalendar();
    };
    $[2] = toggleCalendar;
    $[3] = updateFilter;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleSelect = t2;
  let t3;
  if ($[5] !== resetFilter || $[6] !== toggleCalendar) {
    t3 = () => {
      resetFilter();
      toggleCalendar();
    };
    $[5] = resetFilter;
    $[6] = toggleCalendar;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleReset = t3;
  const t4 = formattedDate ? "tertiary-selected" : "tertiary";
  const t5 = formattedDate ? "text-text-brand-primary" : "text-text-secondary";
  let t6;
  if ($[8] !== t5) {
    t6 = cn("size-2", t5);
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <CalendarIcon className={t6} aria-hidden={true} />;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== formattedDate || $[13] !== t) {
    t8 = formattedDate ?? t("start-date");
    $[12] = formattedDate;
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t7 || $[17] !== t8) {
    t9 = <SheetTrigger asChild={true} className="order-2 flex flex-2 items-center gap-1 sm:hidden"><Button size="sm" variant={t4} className="capitalize">{t7}{t8}</Button></SheetTrigger>;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("date-of-activity");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== selectedDate) {
    t11 = selectedDate ?? new Date();
    $[21] = selectedDate;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = new Date();
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== handleSelect || $[25] !== selectedDate || $[26] !== t11) {
    t13 = <Calendar mode="single" selected={selectedDate} onSelect={handleSelect} weekStartsOn={1} defaultMonth={t11} fromDate={t12} />;
    $[24] = handleSelect;
    $[25] = selectedDate;
    $[26] = t11;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== handleReset || $[29] !== t10 || $[30] !== t13) {
    t14 = <FilterSheetContent title={t10} reset={handleReset}>{t13}</FilterSheetContent>;
    $[28] = handleReset;
    $[29] = t10;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== isOpen || $[33] !== t14 || $[34] !== t9 || $[35] !== toggleCalendar) {
    t15 = <Sheet open={isOpen} onOpenChange={toggleCalendar}>{t9}{t14}</Sheet>;
    $[32] = isOpen;
    $[33] = t14;
    $[34] = t9;
    $[35] = toggleCalendar;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  return t15;
};
export default DateFilterSheet;